import React, { useCallback } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { PremiumFeaturesManagerApiClient } from '@wix/premium-fed-sdk/@api-clients-react';
import { createCdnModuleLoader } from '@wix/premium-fed-sdk/@cdn-loader';
import { Box, Loader } from '@wix/design-system';
import { useQueryParams } from '../../hooks/useQueryParams';
const ConnectDomainCdnLoader = createCdnModuleLoader({
  artifactId: 'com.wixpress.premium.connect-domain',
  libraryName: 'ConnectDomain',
  entry: 'connect-domain-module'
});
const LoadingBox = /*#__PURE__*/React.createElement(Box, {
  align: "center",
  padding: "SP6"
}, /*#__PURE__*/React.createElement(Loader, null));
export const ConnectDomainRoute = _ref => {
  var _studioEligibility$da, _getPremiumEssentials;
  let {
    onManualConnectSuccess
  } = _ref;
  const history = useHistory();
  const {
    getQueryParam
  } = useQueryParams();
  const domainName = getQueryParam('domainName') ?? undefined;
  const metaSiteId = getQueryParam('metaSiteId') ?? undefined;
  const studioEligibility = PremiumFeaturesManagerApiClient.hooks.useIsEligible({
    uniqueName: 'wix_studio',
    includeParentFeature: true
  });
  const isStudio = studioEligibility == null || (_studioEligibility$da = studioEligibility.data) == null ? void 0 : _studioEligibility$da.isEligible;
  const goToSuccess = useCallback(() => {
    if (!domainName || !metaSiteId) {
      return;
    }
    onManualConnectSuccess == null || onManualConnectSuccess({
      domainName,
      metaSiteId
    });
  }, [domainName, metaSiteId, onManualConnectSuccess]);
  if (!domainName || !metaSiteId) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  if (studioEligibility != null && studioEligibility.isLoading) {
    return LoadingBox;
  }
  const locale = ((_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.i18n) == null ? void 0 : _getPremiumEssentials.language) ?? 'en';
  return /*#__PURE__*/React.createElement(ConnectDomainCdnLoader.Wrapper, {
    Loading: LoadingBox,
    options: {
      retry: false
    }
  }, _ref2 => {
    let {
      ConnectDomainModule
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Suspense, {
      fallback: LoadingBox
    }, /*#__PURE__*/React.createElement(ConnectDomainModule.SDK.Components.MobileConnectDomain, {
      domainName: domainName,
      msid: metaSiteId,
      locale: locale,
      brand: isStudio ? 'EditorX' : 'Wix',
      translations: {},
      onBackClick: () => history.goBack(),
      onSuccess: goToSuccess
    }));
  });
};
//# sourceMappingURL=ConnectDomainRoute.js.map